<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddTestimonial" class="ml-auto">
                    <span class="color-white">
                        add testimonial
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="allTestimonials" style="width: 100%">
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="logo" prop="image2URL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.image2URL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.image2URL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="title En" align="right">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                   
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" align="right" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="description Ar"  >
                        <template #default="scope">
                           <div class="rtl text-right">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                    
                  
                    
                    <el-table-column label="Operations" width="100 ">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit testimonial"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditTestimonial(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this value status?"
                                @confirm="changeTestimonialStatus(scope.row)"
                                @cancel="scope.row.active = !scope.row.active "
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.active"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllTestimonials(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.home?.testimonials?.list || []
        },
    },
    data(){
        return{
            allTestimonials:[],
            isAddTestimonial:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllTestimonials.length){
            this.getAllTestimonials();
        }else{
           
            this.allTestimonials = this.cachedAllTestimonials;
        }
    },
    
    methods:{
       
        async getAllTestimonials(){
            
            const response = await this.$store.dispatch('getAllTestimonials');
          
            this.allTestimonials = response.data;
            
            
        },
    
        async changeTestimonialStatus(testimonialData){
            
            let dataToSend = {
                status: testimonialData.status,
                id:testimonialData.id
            }
            const response = await this.$store.dispatch('changeTestimonialStatus',dataToSend);
            if (response.data.status == 1){
                this.getAllTestimonials();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentTestimonial = this.allTestimonials.find(testimonial => testimonial.id == testimonialData.id )
                currentTestimonial.status = !currentTestimonial.status
            }
            
        },
       
        async handleAddTestimonial(){
            this.$router.push({
                name:'manage-testimonial',
            })
           
        },
        async handleEditTestimonial(testimonial){
            await this.$store.dispatch('storeCurrentTestimonialToView',testimonial)
            this.$router.push({
                name:'manage-testimonial',
                params:{
                    id:testimonial.id
                }
            })
        }
    }
}
</script>